/** @jsx isolateComponent */

import { keyframes } from '@emotion/core';
import { Interpolation } from '@emotion/css';
import { isolateComponent, labelStyles } from '@zapier/common-utils';
import { Colors } from '@zapier/design-system/src/theme';

const streakAnimation = keyframes({
  '0%': {
    transform: 'translateX(-100%)',
  },
  '100%': {
    transform: 'translateX(100%)',
  },
});

const Styles = labelStyles(__filename, {
  root: {
    backgroundColor: Colors.grey100,
    borderRadius: 5,
    overflow: 'hidden',
    position: 'relative',

    '&::before': {
      animation: `${streakAnimation} 1s ease-in-out infinite`,
      content: '""',
      background: `linear-gradient(90deg, transparent, ${Colors.white}, transparent)`,
      opacity: 0.3,
      position: 'absolute',
      top: '0',
      right: '0',
      bottom: '0',
      left: '0',
    },
  },
});

type SkeletonBlockProps = {
  /**
   * An aspect ratio to maintain for the element.
   * **Important:** This takes precedence over `height`.
   */
  aspectRatio?: number;
  /**
   * Any valid CSS `height` value.
   */
  height?: number | string;
  /**
   * Any valid CSS `width` value.
   */
  width: number | string;
};

const SkeletonBlock = (props: SkeletonBlockProps) => {
  const style = {
    width: props.width,
    paddingTop: props.aspectRatio
      ? `calc(${props.width} / ${props.aspectRatio})`
      : props.height,
  };
  return (
    <div
      css={Styles.root as Interpolation}
      data-testid="SkeletonBlock"
      style={style}
    />
  );
};

SkeletonBlock.defaultProps = {
  width: '100%',
};

export default SkeletonBlock;
